export const quoteComparisonLimit = 4;
